module.exports = __webpack_public_path__ + "img/codapay-smokegrey.b4eea4d4.png";